import { HHBox, HHButton } from '@hinge-health/react-component-library';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface BackLinkProps {
  /** Absolute path; build it from `useBasePath()`, never a literal. */
  to: string;
  label: string;
  testId: string;
}

/**
 * Text button with a leading arrow that takes the operator up one level.
 * Sentence case on purpose: the theme title-cases buttons, and a nav link
 * should read like a link.
 */
export const BackLink = ({ to, label, testId }: BackLinkProps): JSX.Element => {
  const navigate = useNavigate();

  return (
    <HHBox>
      <HHButton
        hhVariant="variant-bypass"
        variant="text"
        size="small"
        startIcon={<ArrowBack />}
        sx={{ textTransform: 'none' }}
        data-testid={testId}
        onClick={(): void => navigate(to)}
      >
        {label}
      </HHButton>
    </HHBox>
  );
};
